import React from "react";
import Moment from 'react-moment';

const Table = (props) => {

    const DisplayAllData = props.DisplayAllData;
    const type = props.type;
    const handleCheckboxClick = props.handleCheckboxClick;

    return (
        <>
            <table className="table table-sm mt-3">
                <thead className="table-light">
                    {
                        type ? <tr>
                            <th>Date </th>
                            <th>Company Name </th>
                            <th className="cursor-pointer">Jobtitle</th>
                            <th className="cursor-pointer">Days</th>
                            <th>Active</th>
                        </tr> : <tr>
                            <th scope="col">Name </th>
                            <th scope="col" className="cursor-pointer">Register Method</th>
                            <th scope="col" className="cursor-pointer">Date</th>
                            <th scope="col">Email</th>
                        </tr>
                    }
                </thead>
                <tbody>
                    {
                        DisplayAllData.length > 0 ? DisplayAllData.map((Data, id) => {
                            const jobId = Data.jobId;
                            return (
                                <React.Fragment key={id}>
                                    <tr>

                                        {
                                            type === 'alljobs' ? <td className="table-light">
                                                <Moment format="DD/MM/YYYY">
                                                    {Data.updatedAt}
                                                </Moment>
                                            </td> : <td className="table-light">
                                                {Data.name}
                                            </td>
                                        }

                                        {
                                            type === 'alljobs' ? <td className="table-light">
                                                {Data.companyName}
                                            </td> : <td className="table-light">
                                                <div className="badge rounded-pill bg-danger"> {Data.registerType}</div>
                                            </td>
                                        }


                                        {
                                            type === 'alljobs' && <td className="table-light">
                                                <div className="badge rounded-pill bg-danger">{Data.jobTitle}</div>
                                            </td>
                                        }

                                        {
                                            type === 'alljobs' ? <td className="table-light">
                                                {Data.daysRemaining}
                                            </td> : <td className="table-light">
                                                <Moment format="DD/MM/YYYY">
                                                    {Data.createdAt}
                                                </Moment>
                                            </td>
                                        }


                                        {
                                            type === 'alljobs' && <td>
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        role="switch"
                                                        id={`flexSwitchCheckChecked-${jobId}`}
                                                        defaultChecked={Data.isActive}
                                                        onChange={(e) => handleCheckboxClick(jobId, Data.isActive, e.target.checked)}
                                                    />
                                                </div>
                                            </td>
                                        }

                                        <td className="table-light">
                                            {
                                                <h6 className="username mt-2" style={{ 'fontSize': '13px' }}>
                                                    {Data.email}
                                                </h6>
                                            }
                                        </td>
                                    </tr>
                                </React.Fragment>
                            )
                        })
                            : <h5 className="text-center">No JobSeeker Found</h5>
                    }
                </tbody>
            </table >
        </>
    );
};

export default Table;
